"use client";

import Image from "next/image";
import Link from "next/link";
import Write from "../assets/write.svg";
import ArrowDown from "../assets/arrowdown.svg";
import { useState } from "react";
import { useSession } from "next-auth/react";
import { ProfileDropdown } from "./ProfileDropdown";

export function AuthUser() {
  const [dropdownIsOpen, setDropDownIsOpen] = useState(false);

  const { data: session } = useSession();

  function toggleDropdown(): void {
    setDropDownIsOpen((dropdownIsOpen) => !dropdownIsOpen);
  }

  if (!session) return null;
  return (
    <div className="flex content-center flex-wrap gap-5 relative">
      <Link
        href="/blog/new"
        className="flex gap-2 flex-row content-center flex-wrap"
      >
        Write
        <Write />
      </Link>
      <button
        onClick={toggleDropdown}
        className="flex gap-1 items-center text-white"
      >
        <Image
          src={session.user?.image as string}
          alt={`profile photo of ${session.user?.name || "you"}`}
          width={35}
          height={35}
          className="aspect-square rounded-full"
        />
        <ArrowDown />
      </button>
      {dropdownIsOpen && <ProfileDropdown />}
    </div>
  );
}
